import { $_WC } from "@/confs/common.const.js";

export default {
    computed: {
        $cp() {
            return $_WC.cp;
        },
        $assets() {
            return $_WC.assets;
        }
    },
}
